import { assign, createMachine } from 'xstate';

export const requestStateMachine = createMachine({
  id: 'buttonState',
  initial: 'idle',
  context: {
    errorMessage: null,
    error: null,
  },
  states: {
    idle: {
      on: {
        START: 'loading',
        ERROR: {
          target: 'error',
          actions: [
            assign({
              error: (_, event: any) => event.error,
              errorMessage: (_, event: any) => event.errorMessage,
            }),
          ],
        },
      },
    },
    loading: {
      on: {
        RESUME: 'idle',
        ERROR: {
          target: 'error',
          actions: [
            assign({
              error: (_, event: any) => event.error,
              errorMessage: (_, event: any) => event.errorMessage,
            }),
          ],
        },
      },
    },
    error: {
      on: {
        START: 'loading',
        RESUME: {
          target: 'idle',
          actions: [
            assign({
              error: null,
              errorMessage: null,
            }),
          ],
        },
      },
    },
  },
});
